module.exports = __webpack_public_path__ + "img/triangle-down.svg";